import { FinancialWorkspaceValueObjectsPayrollGroupByEnum } from 'generated/resources/graphql'

import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'

const DEFAULT_GROUP_BY = InsightTableGroupBy.LineItem

// TODO: Remove when payroll export starts using the new filters
export const getGroupBy = (value: string) => {
  // eslint-disable-next-line
  return (Object.entries(InsightTableGroupBy)
    .find(([_, v]) => v === value)?.[0]
    .toLowerCase() || DEFAULT_GROUP_BY) as FinancialWorkspaceValueObjectsPayrollGroupByEnum
}
